import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import { LIBRARY_BASE_URL } from "../props";
import { equals, includes } from "ramda";
import { isBlank } from "../util/ext";

const getBadgeSrc = fileName =>
  `${LIBRARY_BASE_URL}/ext/api/badges/${fileName}`;

const useStyles = makeStyles(theme => ({
  awardGrid: {
    height: "80%",
    width: "80%",
    objectFit: "contain",
  },

  awardList: {
    height: 90,
  },

  badge: {
    padding: 10,
  },

  badgeBlack: {
    background: "white",
  },

  badgeGrid: {
    height: 50,
    width: "100%",
    objectFit: "contain",
  },

  badgeList: {
    height: 50,
  },

  badgeWhite: {
    background: "black",
  },
}));

const Badge = ({ badge, orientation = "list" }) => {
  const classes = useStyles();
  return isBlank(badge) ? null : (
    <img
      className={clsx(
        {
          [classes.award]: equals(badge.fileType, "award"),
          [classes.badge]: includes(badge.fileType, ["black", "white"]),
          [classes.badgeWhite]: equals(badge.fileType, "white"),
          [classes.badgeBlack]: equals(badge.fileType, "black"),
        },
        {
          [classes.awardList]:
            equals(badge.fileType, "award") && equals(orientation, "list"),
          [classes.awardGrid]:
            equals(badge.fileType, "award") && equals(orientation, "grid"),
          [classes.badgeList]:
            includes(badge.fileType, ["black", "white"]) &&
            equals(orientation, "list"),
          [classes.badgeGrid]:
            includes(badge.fileType, ["black", "white"]) &&
            equals(orientation, "grid"),
        },
      )}
      src={getBadgeSrc(badge.fileName)}
      alt="Badge"
    />
  );
};

export default Badge;
